module.exports = ".btn-default, .btn-default:focus {\n  border-color: #d9d9d9; }\n\n.progress {\n  width: 130px;\n  height: 19px;\n  position: relative;\n  text-align: center;\n  margin-bottom: 0;\n  border-radius: 3px; }\n\n.progress .progress-label {\n    position: absolute;\n    left: 50%;\n    -webkit-transform: translateX(-50%);\n    transform: translateX(-50%);\n    color: #fff;\n    font-size: 11px;\n    font-weight: 600;\n    line-height: 19px; }\n"


//////////////////
// WEBPACK FOOTER
// ./libs/chassis-datatable/src/components/values/progress/progress.component.scss
// module id = ./libs/chassis-datatable/src/components/values/progress/progress.component.scss
// module chunks = main